import Vue from 'vue';
import { MdTable, MdList, MdContent, MdRipple, MdDatepicker, MdDialog, MdButton, MdCheckbox, MdField, MdMenu, MdSwitch, MdCard, MdIcon, MdProgress } from 'vue-material/dist/components';
import App from './App.vue';
import axios from 'axios'
import VueRouter from 'vue-router';
import VueCookies from 'vue-cookies';
import LoginComponent from './components/LoginComponent.vue';
import FirstLoginClientComponent from './components/FirstLoginClientComponent.vue';
import FirstLoginNoClientComponent from './components/FirstLoginNoClientComponent.vue';
import QueryProvidersComponent from './components/QueryProvidersComponent.vue';
import HomeComponent from './components/HomeComponent.vue';
import ChangePasswordComponent from './components/ChangePasswordComponent.vue';
import NavigationBarsComponent from './components/NavigationBarsComponent.vue'
import ChangeSignatureComponent from './components/ChangeSignatureComponent.vue';
import AdvancePaymentManagementComponent from './components/AdvancePaymentManagementComponent.vue';
import AdvancePaymentofMarkedOrdersComponent from './components/AdvancePaymentofMarkedOrdersComponent.vue';
import RealAdvancePaymentofMarkedOrdersComponent from './components/RealAdvancePaymentofMarkedOrdersComponent.vue';
import InvoicesAlertsComponent from './components/InvoicesAlertsComponent.vue';
import ConditionsAlertsComponent from './components/ConditionsAlertsComponent.vue';
import RegisterConfirmingComponent from './components/RegisterConfirmingComponent.vue';
import PaymentAccountComponent from './components/PaymentAccountComponent.vue';
import AutomaticAdvanceComponent from './components/AutomaticAdvanceComponent.vue';
import ComponentsCatalogComponent from './components/ComponentsCatalogComponent.vue';
import QueryOrdersPaymentsManagementComponent from './components/QueryOrdersPaymentsManagementComponent.vue';
import TransferDetailComponent from './components/TransferDetailComponent.vue';
import ChangeAccountComponent from './components/ChangeAccountComponent.vue';
import ForgotPasswordComponent from './components/ForgotPasswordComponent.vue';
import ModifyDataComponent from './components/ModifyDataComponent.vue';
import SignTransferComponent from './components/SignTransferComponent.vue';
import ControlSesionComponent from './components/ControlSesionComponent.vue';
import Vulidate from 'vuelidate';
import locales from './assets/locales/locales-es.json';
import Loading from 'vue-loading-overlay';
import VueExcelXlsx from "vue-excel-xlsx";

//import vSelect from 'vue-select'


Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(Vulidate);
Vue.use(MdTable);
Vue.use(MdList);
Vue.use(MdContent);
Vue.use(MdRipple);
Vue.use(MdDatepicker);
Vue.use(MdButton);
Vue.use(MdDialog);
Vue.use(MdCheckbox);
Vue.use(MdField);
Vue.use(MdMenu);
Vue.use(MdSwitch);
Vue.use(MdCard);
Vue.use(MdIcon);
Vue.use(MdProgress);
Vue.use(VueCookies);
Vue.use(Loading, {
  color: '#005155',
  loader: "spinner",
  width: 64,
  height: 64,
  backgroundColor: '#ffffff',
  opacity: 0.5,
  zIndex: 999
});
Vue.use(VueExcelXlsx);

Vue.prototype.$locales=locales; //aqui se declara de manera global el archivo locales que utilizamos, que contiene cabeceras, titulos de secciones y ventanas

Vue.material.locale= { //spanish patch for datepicker
    // range for datepicker
    startYear: 1900,
    endYear: 2500,
    dateFormat: 'dd/MM/yyyy',
    // i18n strings
    days: ['Domingo', 'Lunes', 'Martes', 'Mi\u00E9rcoles', 'Jueves', 'Viernes', 'S\u00E1bado'],
    shortDays: ['Dom', 'Lun', 'Mar', 'Mi\u00E9', 'Jue', 'Vie', 'S\u00E1b'],
    shorterDays: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'],
    shorterMonths: ['E', 'F', 'Mr', 'Ab', 'My', 'Jn', 'Jl', 'Ag', 'Se', 'O', 'N', 'D'],

    // `0` stand for Sunday, `1` stand for Monday
    firstDayOfAWeek: 1,

    cancel: 'Cancelar',
}

// caducidad para todas las cookies al finalizar la sesion de navegacion
Vue.$cookies.config("0");

//headers parametrizados axios
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.common['X-CHANNEL-KEY'] = 'B';
axios.defaults.headers.common['X-APPLICATION-ID'] = 'PC';
axios.defaults.headers.common['cache-control'] = 'no-cache';
axios.defaults.params = {refresh:false};

//INTERCEPTORES
//PARA PARAMETRIZAR URL ANTES DE CADA LLAMADA
axios.interceptors.request.use(config => {
  if(!config.params['refresh']){ //solo ponemos la url cuando es la primera llamada
    //url del entorno parametrizada
    config.url=process.env.VUE_APP_BASE_URL+config.url;
  }
  return config;
}, error => {
  // handle the error
  return Promise.reject(error);
});


axios.interceptors.response.use((response) => {
  //PARA PAGINACION
  if(response.data.paging) { //si hay indicador de paginacion
    const config = response.config; //cogemos la configuracion de la request de la que viene la respuesta
    if(!response.config.data){ //si no hay data, significa que esta es la primera pagina
      config.data=new Array(); //en el config.data iremos acumulando los registros de las paginaciones
    }else{
      config.data=JSON.parse(config.data); //en las paginaciones siguientes, nos vendra como una string por lo que hay que parsear antes de hacer push
    }
    if(response.data.data) {
      response.data.data.forEach(element => {
        config.data.push(element); //agregamos los registros de esta ejecucion
      });
    }
    var paginacion = response.data.paging;
    if(paginacion.hasMorePages == true) { //si hay mas paginas
      config.params['paginationKey'] = paginacion.nextPaginationKey; //paginationKey para la siguiente ejecucion
      config.params['refresh'] = true; //indicador de segunda llamada para evitar que se duplique la ip de la URL
      return new Promise((resolve, reject) => { //lanzamos una peticion identica a la inicial, pero con los params de arriba y el data acumulado
        axios.request(config).then(response => {
          resolve(response);
        }).catch((error) => {
          reject(error);
        })
      });
    }else{ //si es la ultima pagina, ya podemos hacer return de todos los registros acumulados en el data
      response.data.data=config.data;
      return response;
    }
  }else{ //si no hay indicador de paginacion, devolvemos la response que viene directa del API
    return response;
  }
}, error => {
  //PARA REFRESCAR TOKEN CUANDO PROCEDA
  // Return any error which is not due to authentication back to the calling service
  if(error.response!=null){
    if (error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  }


  // Try request again with new token
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams();
      params.append('refresh_token',  Vue.$cookies.get('RT'));
      params.append('grant_type', 'refresh_token');
      const options = {
        headers: {
            'Authorization':'Basic UENfRXVyb2NhamE6c2VjcmV0X3Bj'
        }
      };
    axios.post('auth-server/oauth/token', params,options)
      .then(response => {

        Vue.$cookies.set('RT',response.data.refresh_token);

        resolve(response.data.access_token);
      })
      .catch((error) => {
        reject(error);
      });
  }).then((token) => {

    // New request with new token
    const config = error.config;
    config.params['refresh'] = true; //indicador de segunda llamada
    config.headers['Authorization'] = `Bearer ${token}`;

    return new Promise((resolve, reject) => {
      axios.request(config).then(response => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`; //si va bien lo ponemos default para las proximas llamadas
        resolve(response);
      }).catch((error) => {
        reject(error);
      })
    });

  })
  .catch((error) => {
    Promise.reject(error);
  });
});

Vue.prototype.$http = axios;

const routes = [
  {path: '', component: ControlSesionComponent,
    beforeEnter(to,from,next){
      let usuario = Vue.$cookies.get('providerSelected');
      let proveedores = Vue.$cookies.get('providersList');
      let refresh = Vue.$cookies.get('RT');
      let userNumber = Vue.$cookies.get('userNumber');
      let userName = Vue.$cookies.get('userName');
      if(usuario!=null || proveedores!=null || refresh!=null || userNumber!=null || userName!=null){ //si venimos de dentro de la app
        Vue.$cookies.keys().forEach(cookie => Vue.$cookies.remove(cookie)); //elimina todas las cookies -- cierra sesion
      }
      next();
    },
    children:[
      {path: 'identificacion',name:'login', component: LoginComponent},
      {path: '', component: LoginComponent},
      {path: 'olvido-contrasena', component: ForgotPasswordComponent},
      {path: 'primera-identificacion-no-cliente', component: FirstLoginNoClientComponent},
      {path: 'primera-identificacion', component: FirstLoginClientComponent},
      {path: 'primera-identificacion/registro-confirming', name:'registroCliente', component: RegisterConfirmingComponent,
        beforeEnter(to,from,next){
          if(to.params.token){ //indicador de que el token o clave de registro es valido
            next();
          }else{
            next('/primera-identificacion-no-cliente');
          }
        }
      },
    ]
  },
  {path: '/consulta-proveedores-apoderado', component: QueryProvidersComponent,
    beforeEnter(to,from,next){
      if(axios.defaults.headers.common['Authorization']==null){ //si se refresca la pagina se perdera el AT y redirigiremos a login
        Vue.$cookies.keys().forEach(cookie => Vue.$cookies.remove(cookie)); //elimina todas las cookies -- cierra sesion
        next('');
      }
      let token = Vue.$cookies.get('RT');
      if(token!=null){
        next();
      }else{
        next('/');
      }
    }
  },
  {
    path: '/onesaitConfirmingProviders', 
    component: NavigationBarsComponent, //ESTE COMPONENTE PARAMETRIZA EL CONTROL DE AUTENTICACION PARA TODOS LOS QUE DESCIENDEN DE EL
    beforeEnter(to,from,next){
      if(axios.defaults.headers.common['Authorization']==null){ //si se refresca la pagina se perdera el AT y redirigiremos a login
        Vue.$cookies.keys().forEach(cookie => Vue.$cookies.remove(cookie)); //elimina todas las cookies -- cierra sesion
        next('');
      }
      let usuario = Vue.$cookies.get('providerSelected');
      let proveedores = Vue.$cookies.get('providersList');
      let refresh = Vue.$cookies.get('RT');
      let userName = Vue.$cookies.get('userName');
      let userNumber = Vue.$cookies.get('userNumber');
      if(usuario!=null && proveedores!=null && refresh!=null && userNumber!=null && userName!=null){ //todos estos datos los devuelve el login asi que deberian estar presentes en todas
        if(to.path=='/onesaitConfirmingProviders' || to.path=='/onesaitConfirmingProviders/'){ //si hay algun listo que pone estas rutas
          next('/onesaitConfirmingProviders/home'); //lo redirigimos a home
        }else{
          next();
        }
      }else{
        next('/');
      }
    },
    children:[
      {path: 'ajustes/modificar-contrasena', component: ChangePasswordComponent},
      {path: 'ajustes/modificar-claveFirma', component: ChangeSignatureComponent},
      {path: 'ajustes/alertas/facturas', name:'alertasMisFacturas', component: InvoicesAlertsComponent},
      {path: 'ajustes/alertas/condiciones-alertas', name:'condicionesAlertas', component: ConditionsAlertsComponent},
      {path: 'ajustes/datos-personales/modificar-datos', component: ModifyDataComponent},
      {path: 'condiciones-especiales/cuenta-abono', component: PaymentAccountComponent},
      {path: 'condiciones-especiales/anticipo-automatico', component: AutomaticAdvanceComponent},
      {path: 'gestion-anticipos', name:'gestionAnticipos', component: AdvancePaymentManagementComponent},
      {path: 'gestion-anticipos/simulacion-anticipo-ordenes-marcadas', name:'simulacionAnticipo', component: AdvancePaymentofMarkedOrdersComponent},
      {path: 'gestion-anticipos/anticipo-ordenes-marcadas', name:'anticipoOrdenes', component: RealAdvancePaymentofMarkedOrdersComponent},
      {path: 'ordenes-gestion-pagos/consulta', name:'consultaOrdenesGestionPagos', component: QueryOrdersPaymentsManagementComponent},
      {path: 'ordenes-gestion-pagos/consulta/detalleTransferencia', name:'detalleTransferencia', component: TransferDetailComponent},
      {path: 'firma', name:'firma', component: SignTransferComponent,
        beforeEnter(to,from,next){
          if(to.params.firma){ //si accede tras realizar una operacion que requiere firma
            to.params.urlComponente=from.path; //establecemos la ruta del componente que accede a la firma por si se quiere regresar a este despues
            next();
          }else{
            next('/onesaitConfirmingProviders/home'); //si no, lo redirigimos a home
          }
        },  
      },
      {path: 'cambiar-cuenta', component: ChangeAccountComponent},
      {path: 'componentes', component: ComponentsCatalogComponent},
      {path: 'home', name:'home', component: HomeComponent}
    ]
  },
  {path: '*', component: LoginComponent,
    beforeEnter(to,from,next){
      let usuario = Vue.$cookies.get('providerSelected');
      let proveedores = Vue.$cookies.get('providersList');
      let refresh = Vue.$cookies.get('RT');
      let userNumber = Vue.$cookies.get('userNumber');
      let userName = Vue.$cookies.get('userName');
      if(usuario!=null || proveedores!=null || refresh!=null || userNumber!=null || userName!=null){ //si venimos de dentro de la app
        Vue.$cookies.keys().forEach(cookie => Vue.$cookies.remove(cookie)); //elimina todas las cookies -- cierra sesion
      }
      next();
    },
  }
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
